export function Terms(): JSX.Element {
  return (
    <article>
      <h1 className="text-[28px] font-semibold text-ink mb-2">服务条款</h1>
      <p className="text-ink-muted mb-10">最后更新：2026 年 4 月</p>

      <div className="space-y-8 text-[14px] text-ink-muted leading-relaxed">
        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">服务说明</h2>
          <p>
            哪都通提供 AI 模型 API 网关服务，将用户的 API 请求路由到上游模型厂商（如 Anthropic、OpenAI）并返回响应。我们是技术中间层，不生产、训练或修改任何 AI 模型。
          </p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">账户注册</h2>
          <ul className="space-y-1.5">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>你需要提供有效邮箱注册账户</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>你有责任妥善保管 API Key，因泄露造成的费用由你承担</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>每个自然人或法人实体限注册一个账户</span>
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">计费与支付</h2>
          <ul className="space-y-1.5">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>采用预充值模式，余额不足时 API 请求将被拒绝</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>按实际 Token 用量计费，费用在请求完成后从余额中扣除</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>模型价格、渠道折扣和汇率可能随时调整，调整后对新请求即时生效</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>已充值的余额不支持退款，特殊情况请联系客服协商</span>
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">使用规范</h2>
          <p className="mb-3">使用我们的服务时，你不得：</p>
          <ul className="space-y-1.5">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>违反中华人民共和国法律法规及上游模型厂商的使用政策</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>生成违法、有害、侵权或欺诈性内容</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>对服务进行逆向工程、压力测试或恶意攻击</span>
            </li>
          </ul>
          <p className="mt-3">
            违反上述规定的账户将被暂停或永久封禁，余额不予退还。
          </p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">服务可用性</h2>
          <p>
            我们努力维持高可用性，但不承诺 100% 的服务可用率。因上游厂商故障、网络中断、不可抗力等原因导致的服务中断，我们不承担赔偿责任。对于计划内的维护，我们会提前通知。
          </p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">免责声明</h2>
          <ul className="space-y-1.5">
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>AI 模型的输出内容由上游厂商的模型生成，我们不对其准确性、合法性或适用性负责</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>你对通过我们服务生成的内容的使用承担全部责任</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-claude mt-0.5">·</span>
              <span>我们的最大赔偿责任不超过你在争议发生前 30 天内支付的费用总额</span>
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">条款变更</h2>
          <p>
            我们可能不时更新本服务条款。重大变更将通过注册邮箱通知。继续使用服务即表示接受更新后的条款。
          </p>
        </section>

        <section>
          <h2 className="text-[18px] font-semibold text-ink mb-3">联系方式</h2>
          <p>
            对本服务条款有任何问题，请联系：<a href="mailto:support@nadoutong.org" className="text-claude hover:underline">support@nadoutong.org</a>
          </p>
        </section>
      </div>
    </article>
  );
}
